﻿import IncomeTaxService from "./incomeTaxService";

export default class incomeInsuranceCalculatorComponent extends HTMLDivElement {

    constructor() {
        super();
        this.incomeTaxService = new IncomeTaxService();
        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    connectedCallback(e) {
        this.formElement.addEventListener("submit", this.onFormSubmit, false);
    }

    disconnectedCallback() {
        this.formElement.removeEventListener("submit", this.onFormSubmit);
    }

    get canvasElement() {
        return this.getElementsByTagName("canvas")[0];
    }

    get formElement() {
        return this.querySelector("[data-insurance-calculator-form]");
    }

    get formInputElement() {
        return this.formElement.querySelector("[data-insurance-calculator-form-input]");
    }

    get hiddenResultElement() {
        return this.querySelector("[data-insurance-calculator-result]");
    }

    get periods() {
        return this.dataset.periods.split(",");
    }

    get insurances() {
        return this.dataset.insurances.split(";").map(function (item) { return JSON.parse(item) });
    }

    get salary() {
        return this.formInputElement.value.match(/\d+/g).join('');
    }

    get salaryColor() {
        return this.dataset.salarycolor;
    }

    refreshChart() {

        this.incomeTaxService.getIncomeAfterTax(this.salary)
            .then(data => {

                const salary = data;

                // Prepare the periods array
                let periods = ["Lön"];
                periods.push(...this.periods);

                // Prepare the datasets array
                let datasets = [{
                    label: "Lön",
                    data: [salary, 0, 0, 0],
                    backgroundColor: this.salaryColor,
                    barThickness: 'flex'
                }];

                let compensationSumForPeriod1 = 0;
                let compensationSumForPeriod2 = 0;
                let compensationSumForPeriod3 = 0;

                // Fill the datasets with our compensations
                datasets.push(...this.insurances.map(function (item) {

                    const compensationForPeriod1 = Math.max(Math.min(item.Compensation1 * salary, item.Ceiling1) - compensationSumForPeriod1, 0);
                    const compensationForPeriod2 = Math.max(Math.min(item.Compensation2 * salary, item.Ceiling2) - compensationSumForPeriod2, 0);
                    const compensationForPeriod3 = Math.max(Math.min(item.Compensation3 * salary, item.Ceiling3) - compensationSumForPeriod3, 0);

                    compensationSumForPeriod1 += compensationForPeriod1;
                    compensationSumForPeriod2 += compensationForPeriod2;
                    compensationSumForPeriod3 += compensationForPeriod3;

                    return {
                        label: item.Label,
                        data: [0, compensationForPeriod1, compensationForPeriod2, compensationForPeriod3],
                        backgroundColor: item.Color,
                        barThickness: 'flex'
                    }

                }));

                this.renderChart(periods, datasets);

                this.hiddenResultElement.classList.remove("hidden");

            })
            .catch(error => {
                console.log(error);
                if (this.chart) this.chart.destroy();
                this.hiddenResultElement.classList.add("hidden");
            });

    }

    renderChart(labels, datasets) {

        this.canvasElement.classList.remove("hidden");

        if (this.chart) this.chart.destroy();

        let sek = new Intl.NumberFormat('sv-SE', {
            style: 'currency',
            currency: 'SEK',
            maximumFractionDigits: 0
        });

        this.chart = new Chart(this.canvasElement, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: datasets
            },
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        stacked: true
                    }],
                    xAxes: [{
                        stacked: true
                    }]
                },
                legend: {
                    display: false,
                    position: 'bottom',
                    labels: {
                        fontSize: 20,
                        padding: 20,
                        fontColor: 'black'
                    }
                },
                tooltips: {
                    mode: 'x',
                    titleFontSize: 16,
                    titleMarginBottom: 10,
                    bodyFontSize: 12,
                    footerFontSize: 12,
                    footerMarginTop: 10,
                    filter: tooltipItem => tooltipItem.value > 0,
                    callbacks: {
                        footer: function (items) {
                            return 'Totalt: ' + sek.format(items.reduce((partialSum, a) => partialSum + parseFloat(a.value), 0)) + "/mån";
                        },
                        label: function (tooltipItem, data) {
                            var label = data.datasets[tooltipItem.datasetIndex].label || '';
                            if (label) {
                                label = " " + label + ": " + sek.format(tooltipItem.value) + "/mån";
                            }
                            return label;
                        }
                    }
                }
            }
        });
    }

    onFormSubmit(event) {
        event.preventDefault();
        this.refreshChart();
    }

}

customElements.define('income-insurance-calculator', incomeInsuranceCalculatorComponent, { extends: "div" });